/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _SuspendedInfoContainer_settings$ref: unique symbol;
export type SuspendedInfoContainer_settings$ref = typeof _SuspendedInfoContainer_settings$ref;
export type SuspendedInfoContainer_settings = {
    readonly organization: {
        readonly name: string;
    };
    readonly " $refType": SuspendedInfoContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SuspendedInfoContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "organization",
            "storageKey": null,
            "args": null,
            "concreteType": "Organization",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '71f5a9b71c9e3f4c1cffc1b469913be5';
export default node;
